<template>
  <button
    type="button"
    class="btn btn-primary btn-floating btn-lg"
    id="btn-back-to-top"
    ref="mybutton"
    @click="backToTop"
  >
    <i class="fas fa-arrow-up"></i>
  </button>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex justify-content-between">
      <div>
        <h5 class="fw-bold">
          EDYCJA POJAZDU
        </h5>
      </div>
      <div>
        <router-link :to="{ name: 'StoreHouseListing' }" class="btn btn-primary">
          <i class="fa-solid fa-arrow-left"></i>
          Powrót do magazynu
        </router-link>
      </div>
    </div>
    <form @submit.prevent="updateVehicle()">
      <div class="mb-3">
        <label for="place-name" class="form-label">Nr rejestracji</label>
        <input type="text" class="form-control" id="place-name" v-model="vehicle.plateNumber">

        <label for="phone-number" class="form-label mt-2">Numer telefonu:</label>
        <input type="text" class="form-control" id="phone-number" v-model="vehicle.phoneNumber">
      </div>
      <button type="submit" class="btn btn-primary">Zatwierdź</button>
    </form>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import axios from 'axios'
import Swal from 'sweetalert2'
export default {
  name: 'VehicleEditor',
  components: { Navbar },
  data () {
    return {
      vehicle: {}
    }
  },
  created () {
    window.addEventListener('scroll', this.scrollFunction)
  },
  mounted () {
    this.getVehicle()
  },
  methods: {
    async getVehicle () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      try {
        this.vehicle = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${this.$route.params.id}`, config)).data
      } catch (e) {
        console.log(e)
      }
    },
    async updateVehicle () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const putData = {
        textColor: this.vehicle.textColor,
        backgroundColor: this.vehicle.backgroundColor,
        phoneNumber: this.vehicle.phoneNumber,
        plateNumber: this.vehicle.plateNumber,
        name: this.vehicle.name,
        modifiTime: this.vehicle.modifiTime,
        communication: this.vehicle.communication,
        translatorTacho: this.vehicle.translatorTacho,
        mark: this.vehicle.mark,
        model: this.vehicle.model,
        year: this.vehicle.year,
        box: this.vehicle.box,
        tasks: this.vehicle.tasks ?? [],
        status: this.vehicle.status ?? 'Nie określono'
      }
      try {
        await axios.put(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${this.$route.params.id}`, putData, config)
        await Swal.fire('Zaktualizowano pojazd', '', 'success')
        await this.$router.push({name:'StoreHouseListing'})
      } catch (e) {
        console.log(e)
        await Swal.fire('Nie udało się zapisać pojazdu', '', 'error')
      }
    },
    scrollFunction () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'block'
        }
      } else {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'none'
        }
      }
    },
    backToTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style scoped>
#btn-back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
}
</style>
